import { Link } from "react-router-dom";
import { DEVELOPER} from "../utils/constants";
import UserContext from "./UserContext";
import React from "react";
// const About=()=>{
 
 
//  return (  <div className="about">
//     <div className="  text-black bg-slate-200 p-4 hover:bg-slate-300  shadow-lg m-10 w-[600px] h-[450px] rounded-lg border-dotted border-2 hover:border-black border-white ">
//         <img src={DEVELOPER} className="w-[300px] h-[200px] rounded" />
//         <h1 className="text-blue-950">Sheikh Rahat Mahmud<br/>
//         studying CSE, BUET<br/> Web developing Enthusiast</h1>
//       </div>

//     </div>)
// }

class About extends React.Component{
  render(){
    return(
      <div>
      <UserContext.Consumer>
        {({loggedInUser})=>console.log(loggedInUser)}
      </UserContext.Consumer>
      </div>
    )
  }
}
export default About;